
    <div class="reply-loader" *ngIf="_loading || !data">
      <i class="fal fa-spinner fa-spin" [hidden]="_error"></i>
      <i class="fal fa-exclamation-triangle" [hidden]="!_error"></i>
    </div>
    <div class="dice-game-content" *ngIf="!_loading && data">
      <chart [type]="'line'" [data]="chartData" [options]="options"></chart>

      <div class="crash-labels-wrap">
        <div class="crash-label">
          <p>Crashed at</p>
          <h5>x{{ data.multiplayer.multiplier.toFixed(3) }}</h5>
        </div>
        <div class="crash-label" *ngIf="data.win !== true && data.win !== undefined">
          <p>Player did not cashout at time</p>
        </div>
        <div class="crash-label" *ngIf="data.win === true">
          <p>Cashout at</p>
          <h5>x{{ data.cashout.toFixed(3) }}</h5>
        </div>
      </div>
    </div>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-crash.component.ts.ReplyCrashComponent.html